const audioFormats = ["MP3"];

export default audioFormats;
